import React from "react"
import { Col, Row, Table } from "reactstrap"

const AdjustmentOutTotalBox = ({ totals }) => {
  return (
    <Row
      style={{
        marginBottom: 40,
        justifyItems: "center",
        justifyContent: "center",
      }}
    >
      <Col lg={5}>
        <Table
          borderless={false}
          bordered={true}
          style={{ overflow: "hidden" }}
        >
          <tbody>
            <tr>
              <th style={{ color: "#19ada1", fontSize: 13 }}>Total Increase</th>
              <td
                style={{
                  color: "#d08658",
                  fontSize: 13,
                  fontFamily: "monospace",
                }}
              >
                {totals?.total_increase}
              </td>
            </tr>
            <tr>
              <th style={{ color: "#19ada1", fontSize: 13 }}>Total Decrease</th>
              <td
                style={{
                  color: "#d08658",
                  fontSize: 13,
                  fontFamily: "monospace",
                }}
              >
                {totals?.total_decrease}
              </td>
            </tr>
            <tr>
              <th style={{ color: "#19ada1", fontSize: 13 }}>
                Total Adjustments
              </th>
              <td
                style={{
                  color: "#d08658",
                  fontSize: 13,
                  fontFamily: "monospace",
                }}
              >
                {totals?.total_adjustments}
              </td>
            </tr>
          </tbody>
        </Table>
      </Col>
    </Row>
  )
}

export default AdjustmentOutTotalBox
